import { deepLinkExists } from 'APP/model/group/groupModel';

import { IFieldValidationParams, ValidationErrorType } from './fields';

export const channelAliasAsyncValidation = async ({
  value,
  errorToText,
}: IFieldValidationParams): Promise<string | null> => {
  try {
    const result = await deepLinkExists({
      deepLinkAlias: value,
    });

    if (!result) {
      return null;
    }
  } catch (error) {
    console.error(error);
  }

  return errorToText[ValidationErrorType.AlreadyExists] || '';
};
